import Reflux from "reflux";
import fetch from "logic/rest/FetchProvider";
import { singletonStore } from "logic/singleton";
import { qualifyUrl } from "util/URLUtils";
import WatchlistActions from "../actions/WatchlistActions";
const apiPrefix = "/plugins/org.graylog.plugins.watchlist/watchlist";
export const ApiRoutes = {
  WatchlistApiController: {
    update: () => ({ url: `${apiPrefix}/add` }),
    delete: () => ({ url: `${apiPrefix}/remove` }),
    checkStatusForFields: () => ({ url: `${apiPrefix}/checkFieldValues` })
  }
};
const WatchlistStore = singletonStore(
  "enterprise.Watchlist",
  () => Reflux.createStore({
    listenables: [WatchlistActions],
    update(watchlistFieldType, value) {
      const url = qualifyUrl(ApiRoutes.WatchlistApiController.update().url);
      const promise = fetch("POST", url, { type: watchlistFieldType, values: [value] }).then(() => ({
        payload: { watchlistFieldType, value }
      }));
      WatchlistActions.update.promise(promise);
      return promise;
    },
    delete(watchlistFieldType, value) {
      const url = qualifyUrl(ApiRoutes.WatchlistApiController.delete().url);
      const promise = fetch("POST", url, { type: watchlistFieldType, values: [value] }).then(() => ({
        payload: { watchlistFieldType, value }
      }));
      WatchlistActions.delete.promise(promise);
      return promise;
    }
  })
);
export { WatchlistActions, WatchlistStore };
export default WatchlistStore;
